import * as MobileDetect from "mobile-detect";
import { LayoutMapSchema } from "slotworks/config/game-config-schema";
import { Signal } from "signals";
class DeviceInfo {
    /**
     * This will overwrite pixel density to force high-res assets to be loaded
     */
    public isDesktop: boolean;

    /**
     * This is used to determine the canvas layout / size (phone or tablet version)
     */
    public isPhone: boolean;

    public pixelDensity: number;
    /**
     * Use this for debugging only
     */
    public forcePixelDensity: number;

    public layoutId: string; // full layout name mobile.portrait
    public layoutPrefix: string; // prefix at assets like portrait- or none for desktop
    public layoutMain: string; // desktop or mobile, for css classes 

    public layoutsToLoad: string[];

    private mobileDetect: MobileDetect;
    private layoutMap: LayoutMapSchema;

    public onLayoutChange: Signal;

    // refactor
    private landscape: boolean;
    private portraitLayoutId: string;

    constructor() {

        this.mobileDetect = new MobileDetect(window.navigator.userAgent);

        this.isDesktop = this.mobileDetect.mobile() === null;// && !navigator.userAgent.match(/(iPod|iPhone|iPad)/);
        this.isPhone = this.mobileDetect.phone() !== null;

        this.pixelDensity = window.devicePixelRatio;

        this.onLayoutChange = new Signal();
    }

    public selectLayout(layoutMap: LayoutMapSchema) {
        this.layoutsToLoad = [];
        if (this.isDesktop) {
            this.layoutId = layoutMap.desktop;
            this.layoutPrefix = "";
            this.layoutMain = this.layoutId;
            this.layoutsToLoad.push(this.layoutId);
        } else {
            if(layoutMap.mobilePortrait || layoutMap.mobileLandscape) {
                this.layoutMap = layoutMap;     
                if(layoutMap.mobilePortrait3x4 && this.getRatio() > 0.64) {
                    this.portraitLayoutId = layoutMap.mobilePortrait3x4;
                    this.layoutMain = "mobilev2"; // for css classes
                } else {
                    this.portraitLayoutId = layoutMap.mobilePortrait;
                    this.layoutMain = "mobile";
                }            
                this.landscape = this.isLandscape();
                if(this.landscape) {
                    this.layoutId = layoutMap.mobileLandscape;
                } else {
                    this.layoutId = this.portraitLayoutId;
                }            
                this.layoutsToLoad.push(layoutMap.mobileLandscape, this.portraitLayoutId);                   
                if(this.layoutId.indexOf("."))
                    this.layoutPrefix = this.layoutId.split(".")[1] + "-";      
                else 
                    this.layoutPrefix = "";        
            } else {            
                if (this.isPhone) {
                    this.layoutId = layoutMap.phone;
                } else {
                    this.layoutId = layoutMap.tablet;
                }
                this.layoutPrefix = "";
                this.layoutMain = this.layoutId;
                this.layoutsToLoad.push(this.layoutId);
            }                       
        }
        this.layoutMap = layoutMap;
    }

    public orientationChanged(landscape: boolean) {
        if(!this.isDesktop && this.layoutPrefix != "") {
            if(this.landscape != landscape) {
                if(landscape) {
                    this.layoutId = this.layoutMap.mobileLandscape;
                } else {
                    this.layoutId = this.portraitLayoutId;
                }
                if(this.layoutId.indexOf('.') > 0)
                    this.layoutPrefix = this.layoutId.split(".")[1] + "-";
                this.onLayoutChange.dispatch();
                this.landscape = landscape;
            }
        }
    }

    public hasTwoOrientations() {
        return this.layoutPrefix != "";
    }

    public isLandscape() {
        return window.screen.width > window.screen.height;
    }

    public isAppleDevice() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    }

    public isSafari() {
        return /Safari/.test(navigator.userAgent);
    }

    public isIphone5() {
        return this.isAppleDevice() && window.screen.height === (1136 / 2);
    }

    public isSamsungBrowser() {
        return navigator.userAgent.toLowerCase().indexOf("samsungbrowser") > -1;
    }

    public isIE11() {
        return this.getIEVersion() === 11;
    }

    public getRatio() {
        const width = this.isAppleDevice() ? document.documentElement.clientWidth : window.screen.width;
        const height = this.isAppleDevice() ? document.documentElement.clientHeight : window.screen.height;
        if(width > height) 
            return height / width;
        else
            return width / height;
    }

    public getIEVersion() {
        {
            let ua;
            let rv = -1;
            if (navigator.appName === "Microsoft Internet Explorer") {
                ua = navigator.userAgent;
                const re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null) {
                    rv = parseFloat(RegExp.$1);
                }
            } else if (navigator.appName === "Netscape") {
                ua = navigator.userAgent;
                const re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null) {
                    rv = parseFloat(RegExp.$1);
                }
            }
            return rv;
        }
    }
}

export default new DeviceInfo();



// WEBPACK FOOTER //
// ./~/slotworks/utils/device-info.ts